<div class="type-subtype-item-row">
  <!-- Row 1: Type and Sub-Type (cascading pair) -->
  <div class="d-flex gap-3 align-items-end">
    <!-- Type Selection -->
    <div class="flex-fill">
      <kendo-label text="Type" [optional]="true"></kendo-label>
      <cyflare-autocomplete
        [baseUrl]="typeApiUrl()"
        [organizationId]="organizationId()"
        [formGroup]="typeForm"
        [formFieldName]="'selectedType'"
        [textField]="'display_text'"
        [placeholder]="'Select type...'"
        [fetchOnInit]="true"
        [showClear]="true"
        [showDropdown]="true"
        [cacheTtlMs]="300000"
        [disabled]="isRowDisabled()"
        [defaultItem]="selectedTypeItem()"
        (itemSelected)="onTypeSelected($event)"
        (itemCleared)="onTypeCleared()"
      ></cyflare-autocomplete>
    </div>

    <!-- Sub-Type Selection -->
    <div class="flex-fill">
      <kendo-label text="Sub-Type" [optional]="true"></kendo-label>
      <cyflare-autocomplete
        [baseUrl]="subTypeApiUrl()"
        [organizationId]="organizationId()"
        [formGroup]="subTypeForm"
        [formFieldName]="'selectedSubType'"
        [textField]="'display_text'"
        [placeholder]="'Select sub-type...'"
        [fetchOnInit]="true"
        [showClear]="true"
        [showDropdown]="true"
        [cacheTtlMs]="300000"
        [disabled]="isRowDisabled() || subTypeDisabled()"
        [extraQueryParams]="subTypeExtraParams()"
        [defaultItem]="selectedSubTypeItem()"
        (itemSelected)="onSubTypeSelected($event)"
        (itemCleared)="onSubTypeCleared()"
      ></cyflare-autocomplete>
    </div>
  </div>

  <!-- Row 2: Item (independent, filtered by board) -->
  <div class="mt-3 col-6">
    <kendo-label text="Item" [optional]="true"></kendo-label>
    <cyflare-autocomplete
      [baseUrl]="itemApiUrl()"
      [organizationId]="organizationId()"
      [formGroup]="itemForm"
      [formFieldName]="'selectedItem'"
      [textField]="'display_text'"
      [placeholder]="'Select item...'"
      [fetchOnInit]="true"
      [showClear]="true"
      [showDropdown]="true"
      [cacheTtlMs]="300000"
      [disabled]="isRowDisabled()"
      [defaultItem]="selectedItemItem()"
      (itemSelected)="onItemSelected($event)"
      (itemCleared)="onItemCleared()"
    ></cyflare-autocomplete>
    <small class="text-muted d-block mt-1">Based on selected board</small>
  </div>
</div>
